import { render } from "./GSThursdayA.vue?vue&type=template&id=4eb8bce6&scoped=true"
import script from "./GSThursdayA.vue?vue&type=script&scoped=true&lang=js"
export * from "./GSThursdayA.vue?vue&type=script&scoped=true&lang=js"

import "./GSThursdayA.vue?vue&type=style&index=0&id=4eb8bce6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb8bce6"]])

export default __exports__